module.exports = __webpack_public_path__ + "static/media/psychTodayVerified.4aae31b1.png";